import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import "babel-polyfill";
import iView from "iview";
import "iview/dist/styles/iview.css";
//全局变量的声明
import Icon from "vue-svg-icon/Icon.vue";
import globalvariable from "./api/global_variable";
import { localStorages } from "./api/storage/localStorage";
Vue.prototype.GLOBAL = globalvariable;
Vue.prototype.apiUrl = apiUrl;
import filters from "./filters/index";
Vue.prototype.FILTER = filters;
//websocket 方法
import { websocket } from "./api/ccsdk/ISdkSession";
Vue.prototype.websocket = websocket();
Vue.prototype.websocket._reconnectTimes = 0;
import BubbleTips from "./views/WebConference/BubbleTips";
Vue.prototype.BubbleTips = BubbleTips;
Vue.config.productionTip = false;

/*使用svg*/
Vue.component("Icon_Svg", Icon);
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
import VirtualScroller, { RecycleScroller as Comp } from "vue-virtual-scroller";
Vue.use(VirtualScroller);
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
Vue.use(iView);
//使用VueI18n

/*自定义指令*/
import drag from "./directives/directives";
import dragInter from "./directives/directives";
import inputclose from "./directives/directives";
// 添加日志
import "@/api/logs/gensee-logger.min";
Vue.prototype.Logger = new GenseeLogger({ logName: "Web_云视会中" });
//根据用户id判断是否登录
let userInfo = null;
const whiteList = ["/login", "/joinroom"];

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  userInfo =
    localStorage.getItem(`loginInfo_${to.query.uid}`) ||
    (to.query && to.query.sessionKey) ||
    (to.query && to.query.roomId && to.query.userName);
  if (whiteList.indexOf(to.path) !== -1) {
    console.log(to.query.lang);
    if (to.query.lang && to.query.lang == "en-US") {
      if (i18n) {
        i18n.locale = "en";
      }
      localStorages.set("locale", "en");
    } else if (to.query.lang && to.query.lang == "zh-CN") {
      if (i18n) {
        i18n.locale = "zh";
      }
      localStorages.set("locale", "zh");
    } else if (to.query.lang && to.query.lang == "auto") {
      localStorages.remove("locale");
    }
    next();
  } else {
    if (userInfo != null) {
      if (to.path == "/conference") {
        if (
          (to.query && to.query.uid && to.query.roomId) ||
          (to.query && to.query.roomId && to.query.userName) ||
          (to.query && to.query.sessionKey)
        ) {
          if (to.query.lang && to.query.lang == "en-US") {
            if (i18n) {
              i18n.locale = "en";
            }
            localStorages.set("locale", "en");
          } else if (to.query.lang && to.query.lang == "zh-CN") {
            if (i18n) {
              i18n.locale = "zh";
            }
            localStorages.set("locale", "zh");
          } else if (to.query.lang && to.query.lang == "auto") {
            localStorages.remove("locale");
          }
          next();
        } else {
          next({ path: "/login" });
        }
      } else if (to.path == "/index") {
        if (to.query && to.query.uid) {
          next();
        } else {
          next({ path: "/login" });
        }
      } else {
        next();
      }
    } else {
      next({
        path: "/login",
      });
    }
  }
});
import i18n from "./utils/VueI18n.js";
Vue.directive(drag, drag);
Vue.directive(dragInter, dragInter);
Vue.directive(inputclose, inputclose);
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>",
});
